"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetadataUpdate = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../../../json"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Device.ServiceMenu.Schema';
const MetadataItem = effect_1.Schema.Struct({
    key: effect_1.Schema.NonEmptyString,
    value: Json.Value,
}).annotations({
    identifier: `${exports.NAMESPACE}.MetadataItem`,
    description: 'value is required. An item without it is 422, and the inputValidation path is relative to that item (`key`, `value`), not `items[n].key`. Any JSON value is accepted.',
});
/** Metadata patch. `items` has at least one entry. */
exports.MetadataUpdate = effect_1.Schema.Struct({
    items: effect_1.Schema.NonEmptyArray(MetadataItem),
}).annotations({
    identifier: `${exports.NAMESPACE}.MetadataUpdate`,
});
//# sourceMappingURL=schema.js.map